import request from '@Sys~/api/request'
import { apiUrl, type } from './env'
import store from '@Sys~/store'

const bdcUrl = apiUrl.bdcUrl
const gateUrl = apiUrl.gateUrl
const gateGameUrl = apiUrl.gameUrl

function Bac4fn(url, data, method, header) {
  header.header_check_mark = 'no'
  header.header_appkey = store.getters.appkey // （游戏appkey）
  header.header_origin = 2 // （数据来源，1：bi统计数据，2：实时数据）
  header.header_platform = store.getters.environment // （环境类型）
  header.header_userid = store.getters.userId // uid
  header.header_rolesid = store.getters.roles // rolesid
  header.cuid = store.getters.userId // rolesid
  return request({
    headers: header,
    baseURL: bdcUrl,
    url: url,
    method: method,
    data: data,
    withCredentials: true
  })
}

function gatewayBac4fn(url, data, method, header) {
  header.header_appkey = store.getters.appkey // （游戏appkey）
  header.header_origin = 2 // （数据来源，1：bi统计数据，2：实时数据）
  header.header_platform = store.getters.environment // （环境类型）
  header.header_userid = store.getters.userId // uid
  header.header_rolesid = store.getters.roles // rolesid

  return request({
    headers: header,
    baseURL: gateUrl,
    url: url,
    method: method,
    params: method == 'get' ? data : null,
    data: data,
    withCredentials: false
  })
}

// 运营助手应用管理
function AppManage(url, data, method, header) {
  header.header_check_mark = 'no'
  header.header_appkey = store.getters.appkey // （游戏appkey）
  header.header_origin = 2 // （数据来源，1：bi统计数据，2：实时数据）
  header.header_platform = store.getters.environment // （环境类型）
  header.header_userid = store.getters.userId // uid
  header.header_rolesid = store.getters.roles // rolesid
  header.cuid = store.getters.userId // rolesid
  return request({
    headers: header,
    baseURL: gateGameUrl,
    // baseURL: 'http://10.0.13.17:8080',
    url: url,
    method: method,
    params: method == 'get' ? data : null,
    data: data,
    withCredentials: true
  })
}

// 开发助手 日志查询
export function logViewquery(data) {
  return gatewayBac4fn('/api/logView/query', data, 'post', {})
}

// 开发助手 所有事件
export function logViewgetAllEvent(platformType) {
  return gatewayBac4fn('/api/logView/getAllEvent?platformType=' + platformType, {}, 'get', {})
}

// 开发助手 日志面板
export function logViewsqlQuery(data) {
  return gatewayBac4fn('/api/logView/sqlQuery', data, 'post', {})
}

// 运营助手应用详情
export function productinfo() {
//   return Bac4fn('/api/sys/game/detail/' + store.getters.appkey, {}, 'get', {})
  return AppManage('/api/game/detail/' + store.getters.appkey, {}, 'get', {})
}

// 运营助手应用详情下拉值
export function productinfovalue(name, data) {
  // console.log(store.getters.userInfo)
  const parameter = data || ''
  return gatewayBac4fn('/api/view/handleControlByCode?bdcId=' + store.getters.userInfo.bdcId + parameter, {}, 'get', { header_view_code: name })
}

// 数据分析 添加筛选
export function add_filter(data) {
  return gatewayBac4fn('/api/filtering/create', data, 'post', {})
}

// 数据分析 删除筛选
export function delete_filter(id) {
  return gatewayBac4fn('/api/filtering/' + id, id, 'delete', {})
}

// 数据分析 更新常用筛选
export function update_filter(data) {
  return gatewayBac4fn('/api/filtering', data, 'put', {})
}

// 数据分析 常用筛选列表
export function get_filter(menuId) {
  return gatewayBac4fn('/api/filtering/list/' + menuId, {}, 'get', {})
}

// 数据分析 编辑筛选名称
export function edit_filter(data) {
  return gatewayBac4fn('/api/filtering/' + data.id + '/' + data.name, {}, 'put', {})
}

// 数据分析 自定义列 报表全部表头信息
export function get_header(headers) {
  return gatewayBac4fn('/api/headers/all', {}, 'get', headers)
}

// 数据分析 自定义列 获取自定义列列表
export function get_headerList(headers) {
  return gatewayBac4fn('/api/headers/list', {}, 'get', headers)
}

// 数据分析 自定义列 添加自定义列
export function add_header(data, headers) {
  return gatewayBac4fn('/api/headers/create', data, 'post', headers)
}

// 数据分析 自定义列 编辑自定义列
export function edit_header(data, headers) {
  return gatewayBac4fn('/api/headers/update', data, 'put', headers)
}

// 数据分析 自定义列 删除自定义列
export function delete_header(id) {
  return gatewayBac4fn('/api/headers/delete/' + id, {}, 'delete', {})
}

// 数据分析 自定义列 默认自定义列   是否是默认配置, 0:否  1:是
export function default_header(data, headers) {
  return gatewayBac4fn('/api/headers/' + data.id + '/' + data.isDefault, {}, 'put', headers)
}

// 数据分析 自定义列 查看自定义列详情
export function detail_header(data) {
  return gatewayBac4fn('/api/headers/' + data.id, {}, 'get', {})
}

// 数据分析 筛选项接口
export function codeControl() {
  return gatewayBac4fn('/api/view/codeControl?menuId=' + store.getters.currentRoute.meta.id, {}, 'get', {})
}

// 数据分析 模块查询接口
export function ajax_modellist() {
  return gatewayBac4fn('/api/view/codeView?menuId=' + store.getters.currentRoute.meta.id, {}, 'get', {})
}

// 指标布局 内容 修改
export function ajax_updateView(data) {
  return gatewayBac4fn('/api/view/updateView', data, 'post', {})
}

// 运营助手字典管理 字典类型列表
export function queryDictTypeList(dictName, status) {
  return gatewayBac4fn('/api/dict/queryDictTypeList?dictName=' + dictName + '&appkey=' + store.getters.appkey + '&status=' + status, {}, 'get', {})
}

// 运营助手字典管理 字典类型详情
export function queryDictTypeById(cid) {
  return gatewayBac4fn('/api/dict/queryDictTypeById?id=' + cid, {}, 'get', {})
}

// 运营助手字典管理 可绑定父级
export function queryParent(dictType) {
  return gatewayBac4fn('/api/dict/queryParent?dictType=' + dictType + '&appkey=' + store.getters.appkey, {}, 'get', {})
}

// 运营助手字典管理 所有事件
export function queryALLEvents() {
  return gatewayBac4fn('/api/dict/queryALLEvents?appkey=' + store.getters.appkey, {}, 'get', {})
}

// 运营助手字典管理 所有事件下属性
export function queryEventAttrsByEventCode(eventCode, source) {
  return gatewayBac4fn('/api/dict/queryEventAttrsByEventCode?appkey=' + store.getters.appkey + '&eventCode=' + eventCode + '&source=' + source, {}, 'get', {})
}

// 运营助手字典管理 字典添加
export function createDictType(data) {
  return gatewayBac4fn('/api/dict/createDictType', data, 'post', {})
}

// 运营助手字典管理 字典编辑
export function updateDictType(data) {
  return gatewayBac4fn('/api/dict/updateDictType', data, 'post', {})
}

// 运营助手字典管理 删除字典
export function deleteDictTypeById(cid) {
  return gatewayBac4fn('/api/dict/deleteDictTypeById?appkey=' + store.getters.appkey + '&id=' + cid, {}, 'get', {})
}

// 运营助手字典管理 字典数据列表
export function queryDictDataList(params) {
  params.appkey = store.getters.appkey
  return gatewayBac4fn('/api/dictData/queryDictDataList', params, 'get', {})
}

// 运营助手字典管理 字典详情导出
// export function downloadDictDetail(params) {
//     return gatewayBac4fn('/api/dictData/downloadDictDataList?appkey=' + store.getters.appkey + '&dictType=' + params.dictType + '&status=' + params.status + '&dictLabel=' + params.dictLabel, {}, "post",{})
// }

// 运营助手字典管理 字典详情导出
export function downloadDictDetail(data) {
  const paraData = { cuid: store.getters.userId, appkey: store.getters.appkey, ...data }
  console.log(paraData)
  var form = document.createElement('form')
  form.style.display = 'none'
  form.action = gateUrl + '/api/dictData/downloadDictDataList'
  form.method = 'post'
  document.body.appendChild(form)
  for (var key in paraData) {
    if (paraData[key]) {
      var input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      if (key == 'otherParam' || key == 'filts') {
        input.value = JSON.stringify(paraData[key])
      } else {
        input.value = paraData[key]
      }
      form.appendChild(input)
    }
  }

  form.submit()
  form.remove()
}

// 运营助手字典管理 保存字典数据
export function createDictData(data) {
  return gatewayBac4fn('/api/dictData/createDictData', data, 'post', {})
}

// 运营助手字典管理 编辑字典数据
export function updateDictData(data) {
  return gatewayBac4fn('/api/dictData/updateDictData', data, 'post', {})
}

// 运营助手字典管理 删除字典数据
export function deleteDictDataById(cid) {
  return gatewayBac4fn('/api/dictData/deleteDictDataById?id=' + cid, {}, 'get', {})
}

// 运营助手字典管理 同步字典数据
export function synData(dictType) {
  return gatewayBac4fn('/api/dictData/synData?appkey=' + store.getters.appkey + '&dictType=' + dictType, {}, 'get', {})
}

// 运营助手字典管理 上传字典数据
export function uploadData(data) {
  return gatewayBac4fn('/api/dictData/importData', data, 'post', {})
}

// 运营助手字典管理 字典数据父级数据
export function queryDictDataParentList(dictType) {
  return gatewayBac4fn('/api/dictData/queryDictDataParentList?appkey=' + store.getters.appkey + '&dictType=' + dictType, {}, 'get', {})
}

// 运营助手渠道管理 渠道列表
export function queryChannelList(name, type) {
  return gatewayBac4fn('/api/channel/queryChannelList?appkey=' + store.getters.appkey + '&channelName=' + name + '&mark=' + type, {}, 'get', {})
}

// 运营助手渠道管理 渠道列表删除
export function deleteChannelById(cid) {
  return gatewayBac4fn('/api/channel/deleteChannelById?id=' + cid, {}, 'get', {})
}

// 运营助手渠道管理 渠道列表
export function queryCategoryList() {
  return gatewayBac4fn('/api/channel/common/queryCategoryList', {}, 'get', {})
}

// 运营助手渠道管理 运营渠道列表
export function queryAppChannelList(appChannelName) {
  return gatewayBac4fn('/api/channel/queryAppChannelList?appChannelName=' + appChannelName + '&appkey=' + store.getters.appkey, {}, 'get', {})
}

// 运营助手渠道管理 同步渠道
export function syncChannelData(type) {
  return gatewayBac4fn('/api/channel/syncChannelData?type=' + type + '&appkey=' + store.getters.appkey, {}, 'get', {})
}
// 运营助手渠道管理 运营渠道添加
export function saveAppChannel(data) {
  return gatewayBac4fn('/api/channel/saveAppChannel', data, 'post', {})
}

// 运营助手渠道管理 运营渠道编辑
export function updateAppChannel(data) {
  console.log('data', data)

  return gatewayBac4fn('/api/channel/updateAppChannel', data, 'post', {})
}

// 运营助手渠道管理 运营渠道删除
export function deleteAppChannelById(cid) {
  return gatewayBac4fn('/api/channel/deleteAppChannelById?id=' + cid, {}, 'get', {})
}

// 运营助手区服管理 区服列表
export function queryServerList(name, version, openTimeRange, status) {
  return gatewayBac4fn('/api/server/queryServerList?name=' + name + '&appkey=' + store.getters.appkey + '&version=' + version + '&openTimeRange=' + openTimeRange + '&status=' + status, {}, 'get', {})
}

// 运营助手区服管理 同步区服
export function syncServerData() {
  return gatewayBac4fn('/api/server/syncServerData?appkey=' + store.getters.appkey, {}, 'get', {})
}

// 运营助手区服管理 区服添加
export function saveServer(data) {
  return gatewayBac4fn('/api/server/saveServer', data, 'post', {})
}

// 运营助手区服管理 区服编辑
export function updateServer(data) {
  return gatewayBac4fn('/api/server/updateServer', data, 'post', {})
}

// 运营助手区服管理 区服删除
export function deleteServerById(cid) {
  return gatewayBac4fn('/api/server/deleteServerById?id=' + cid, {}, 'get', {})
}

// 运营助手区服管理 版本列表
export function queryServerVersionList() {
  return gatewayBac4fn('/api/server/common/queryServerVersionList', {}, 'get', {})
}

// 运营助手区服管理 状态列表
export function queryServerStateList() {
  return gatewayBac4fn('/api/server/common/queryServerStateList', {}, 'get', {})
}

// 运营助手logtail列表
export function query_logtail(data) {
  return AppManage('/api/logtail/list', data, 'get', {})
}

// 运营助手是否启用logtail
export function open_logtail(data) {
  return AppManage('/api/logtail/open', data, 'get', {})
}

// 运营助手添加logtail
export function add_logtail(data) {
  return AppManage('/api/logtail/create', data, 'post', {})
}

// 运营助手 删除logtai
export function delete_logtail(data) {
  return AppManage('/api/logtail/delete/' + data.id, {}, 'delete', {})
}

// 运营助手编辑logtail
export function edit_logtail(data) {
  return AppManage('/api/logtail/update', data, 'post', {})
}

// 运营助手logtail变更历史
export function query_logtailHistory(data) {
  return AppManage('/api/logtail/update/his/' + data.id, {}, 'get', {})
}

// 查看游戏审核详情
export function detail_audit(data) {
  return AppManage('/api/game/audit/details', data, 'get')
}

// 我的看板 点击添加or修改自定义菜单
export function ajax_addmenu(cid, cname, pids) {
  if (cid == '') {
    var datas = {
      name: cname,
      userId: store.getters.userId,
      gameKey: store.getters.appkey
    }
    if (pids != '') {
      datas.pid = parseInt(pids)
    }
  } else {
    var datas = {
      id: cid,
      name: cname,
      userId: store.getters.userId,
      gameKey: store.getters.appkey
    }
    if (pids != '') {
      datas.pid = parseInt(pids)
    }
  }
  return Bac4fn('/api/sys/menu/saveMenu', datas, 'post', {})
}

// 我的看板 删除菜单
export function ajax_removemenu(cid) {
  return Bac4fn('/api/sys/menu/delMenu?menuId=' + cid + '&userId=' + store.getters.userId, {}, 'get', {})
}

// 我的看板 菜单列表
export function ajax_mymenulist(pid) {
  return Bac4fn('/api/sys/menu/customMenuByKey?gameKey=' + store.getters.appkey + '&userId=' + store.getters.userId + '&pid=' + pid, {}, 'get', {})
}

// 中间表管理 左侧菜单列表
export function ajax_dataworkMenuList() {
  return gatewayBac4fn('/api/datawork/manage/list', {}, 'get', {})
}

// 中间表 分组配置
export function ajax_configGroup(groupId, eventCode) {
  return gatewayBac4fn('/api/datawork/manage/group/addTable?groupId=' + groupId + '&eventCode=' + eventCode, {}, 'get', {})
}

// 中间表 编辑组名
export function ajax_updateGroup(id, pid, name) {
  return gatewayBac4fn('/api/datawork/manage/group/merge?id=' + id + '&pid=' + pid + '&name=' + name, {}, 'get', {})
}

// 中间表 删除组
export function ajax_deleteGroup(id) {
  return gatewayBac4fn('/api/datawork/manage/group/del/' + id, {}, 'get', {})
}

// 中间表管理 详情
export function ajax_manageInfo(eventCode) {
  return gatewayBac4fn('/api/datawork/manage/info/' + eventCode, {}, 'get', {})
}

// 中间表管理 开关状态修改
export function ajax_manageSwitch(id, columnName, value) {
  return gatewayBac4fn('/api/datawork/manage/update/column/' + id + '/' + columnName + '?value=' + value, {}, 'get', {})
}

// 中间表管理 编辑
export function ajax_manageUpdate(data) {
  return gatewayBac4fn('/api/datawork/manage/update/column', data, 'post', {})
}

// 中间表管理 中间表信息修改
export function ajax_manageMenuUpdate(eventCode, columnName, value) {
  return gatewayBac4fn('/api/datawork/manage/update/table/' + eventCode + '?value=' + value + '&columnName=' + columnName, {}, 'get', {})
}

// 元事件管理 事件属性管理--查询
export function ajax_eventdataqueryData(data) {
  return gatewayBac4fn('/api/event/data/queryData?eventType=' + data.eventType + '&isShow=' + data.isShow + '&appkey=' + data.appkey + '&dataType=' + data.dataType + '&findStr=' + data.findStr + '&dataEmpty=' + data.dataEmpty + '&sysType=' + data.sysType + '&status=' + ((data.status || data.status == 0) ? data.status : ''), {}, 'get', {})
}

// 元事件管理 事件属性管理--修改名称和显示状态
export function ajax_eventdataupdateShow(data) {
  return gatewayBac4fn('/api/event/data/updateShow/' + data.dataKey + '?isShow=' + data.isShow + '&dataName=' + data.dataName + '&appkey=' + data.appkey, {}, 'get', {})
}

// 元事件管理 事件属性管理--属性详情
export function ajax_eventdataqueryEvent(data) {
  return gatewayBac4fn('/api/event/data/queryEvent?dataKey=' + data.dataKey + '&isShow=' + data.isShow + '&eventType=' + data.eventType + '&appkey=' + data.appkey + '&platformType=' + data.platformType + '&findStr=' + data.findStr, {}, 'get', {})
}

// 元事件管理 显示状态修改
export function ajax_eventupdateShow(data) {
  return gatewayBac4fn('/api/event/' + data.type + '/updateShow/' + data.id + '?isShow=' + data.isShow, {}, 'get', {})
}

// 元事件管理 自定义事件参数规则
export function queryRuleList() {
  return gatewayBac4fn('/api/event/common/queryRuleList', {}, 'get', {})
}

// 元事件管理 自定义事件参数类型
export function queryTypeList() {
  return gatewayBac4fn('/api/event/common/queryTypeList', {}, 'get', {})
}

// 元事件管理 事件列表
export function ajax_eventqueryEventList(data) {
  return gatewayBac4fn('/api/event/queryEventList?appkey=' + data.appkey + '&platformType=' + data.platformType + '&eventType=' + data.eventType + '&eventName=' + data.eventName + '&eventCode=' + data.eventCode + '&isShow=' + data.isShow, {}, 'get', {})
}

// 元事件管理 事件添加编辑
export function ajax_eventsaveEvent(data) {
  return gatewayBac4fn('/api/event/saveEvent', data, 'post', {})
}

// 元事件管理 事件删除
export function ajax_eventdeleteEventById(data) {
  return gatewayBac4fn('/api/event/deleteEventById?id=' + data.id, {}, 'get', {})
}

// 元事件管理 事件列表
export function ajax_eventqueryEventDataList(data) {
  return gatewayBac4fn('/api/event/queryEventDataList?id=' + data.id, {}, 'get', {})
}

// 元事件管理 事件属性添加
export function ajax_eventsaveEventDataList(data) {
  return gatewayBac4fn('/api/event/saveEventDataList', data, 'post', {})
}

// 元事件管理 事件属性上传
export function ajax_eventimportEventData(data) {
  return gatewayBac4fn('/api/event/importEventData', data, 'post', {})
}

// 元事件管理 事件属性上传后回显
export function ajax_eventimportEventDataAndVerification(data) {
  return gatewayBac4fn('/api/event/importEventDataAndVerification', data, 'post', {})
}

// 元事件管理 事件属性编辑
export function ajax_eventsaveEventData(data) {
  return gatewayBac4fn('/api/event/saveEventData', data, 'post', {})
}

// 元事件管理 事件属性删除
export function ajax_eventdeleteEventDataById(data) {
  return gatewayBac4fn('/api/event/deleteEventDataById?id=' + data.id, {}, 'get', {})
}

// 数据分析数据查询
export function ajax_model4(header, zitiaojian) {
  if (!zitiaojian) {
    zitiaojian = {}
  }

  // header.header_view_code = code; // （指标code）
  // header.header_time_type = timetype; // （时间类型，0m:实时,5m:5分钟,1H:1小时,1D:1天,1W:1周,1M:1月）
  header.header_origin = 2 // （数据来源，1：bi统计数据，2：实时数据）
  header.header_appkey = store.getters.appkey // （游戏appkey）
  header.header_platform = store.getters.environment // （环境类型）
  header.header_userid = store.getters.userId // uid
  header.header_rolesid = store.getters.roles.toString() // rolesid

  for (var key in header) {
    if (/.*[\u4e00-\u9fa5]+.*$/.test(header[key])) {
      header[key] = encodeURI(header[key])
    }
  }

  var extra = {}
  var body = {}
  for (var key in header) {
    if (header.hasOwnProperty(key) === true) {
      extra[key] = header[key]
    }
  }

  // alert('子条件111：'+ JSON.stringify(zitiaojian))
  for (var key in zitiaojian) {
    if (zitiaojian.hasOwnProperty(key) === true) {
      extra[key] = zitiaojian[key]
      body[key] = zitiaojian[key]
      // console.log(body[key])
    }
  }

  delete header.header_channel_code
  delete header.header_app_channel_code
  delete header.header_server_code
  body.extra = extra
  // console.log('body:',body)

  return gatewayBac4fn('/api/sasapi/get', body, 'post', header)
}

// 分析事件list
export function fenxievent() {
  return gatewayBac4fn('/api/metaData/tag/getEvents', {}, 'get', {})
}

// 分析标签list
export function eventlist() {
  return gatewayBac4fn('/api/tag/list?userId=' + store.getters.userId, {}, 'get', {})
}

// 分析标签管理子集
export function getEventsziji(platformType, eventCode, type) {
  return gatewayBac4fn('/api/metaData/tag/getEventAttr?platformType=' + platformType + '&eventCode=' + eventCode + '&type=' + type, {}, 'get', {})
}

// 分析查询
export function fenxisave(data) {
  return gatewayBac4fn('/api/custom/analysis/save', data, 'post', {})
}
// 分析保存
export function fenxiquery(data) {
  return gatewayBac4fn('/api/custom/analysis/query', data, 'post', {})
}

// 查看分组list
export function getGroupByEventAttr(data) {
  return gatewayBac4fn('/api/metaData/tag/getGroupByEventAttr?' + data, {}, 'get', {})
}

// 标签tag查询
export function getTaglist(obj, code) {
  return gatewayBac4fn('/api/tag/getTag?targetCol=' + obj + '&eventCode=' + code, {}, 'get', {})
}

// 指标添加列表
export function ajax_zhibiaoliebiao(mid) {
  return gatewayBac4fn('/api/custom/analysis/list?menuId=' + mid, {}, 'get', {})
}

// 删除已存报表
export function ajax_zhibiaodel(bid) {
  return gatewayBac4fn('/api/custom/analysis/del?id=' + bid, {}, 'get', {})
}

// 查询编辑数据
export function queryByCode(obj) {
  return gatewayBac4fn('/api/custom/analysis/queryByCode?code=' + obj, {}, 'get', {})
}

// 分析 左侧SQL表菜单列表
export function ajax_manageMenuList(data) {
  return gatewayBac4fn('/api/metaData/sql/getEvents', data, 'get', {})
}

// 分享指定人员列表
export function ajax_shareduserlist(mid) {
  return Bac4fn('/api/sys/game/getUsersByKey?menuId=' + mid + '&appkey=' + store.getters.appkey, {}, 'get', {})
}

// 指标应用
export function ajax_createView(data) {
  return gatewayBac4fn('/api/view/createView', data, 'post', {})
}

// 查询选项卡可选的指标
export function ajax_viewlist(vid) {
  return gatewayBac4fn('/api/custom/analysis/listByViewId?viewId=' + vid, {}, 'get', {})
}

// 查询游戏时间节点
export function ajax_getTimeNode() {
  return AppManage('/api/product/time/queryTimesByAppkey', {}, 'get', {})
}

// 分享应用
export function ajax_shareduser(data) {
  return Bac4fn('/api/sys/menu/shared', data, 'post', {})
}

// 分享全员
export function ajax_sharedalluser(mid) {
  return Bac4fn('/api/sys/menu/shared?menuId=' + mid, {}, 'get', {})
}

// 数据分析下载
export function houtaixiazai(header, zitiaojian) {
  if (!zitiaojian) {
    zitiaojian = {}
  }

  header.header_origin = 2 // （数据来源，1：bi统计数据，2：实时数据）
  header.header_appkey = store.getters.appkey // （游戏appkey）
  header.header_platform = store.getters.environment // （环境类型）
  header.header_userid = store.getters.userId // uid
  header.header_rolesid = store.getters.roles.toString() // rolesid

  for (var key in header) {
    if (/.*[\u4e00-\u9fa5]+.*$/.test(header[key])) {
      header[key] = encodeURI(header[key])
    }
  }

  var extra = {}
  var body = {}
  for (var key in header) {
    if (header.hasOwnProperty(key) === true) {
      extra[key] = header[key]
    }
  }

  // alert('子条件111：'+ JSON.stringify(zitiaojian))
  for (var key in zitiaojian) {
    if (zitiaojian.hasOwnProperty(key) === true) {
      extra[key] = zitiaojian[key]
      body[key] = zitiaojian[key]
      // console.log(body[key])
    }
  }

  delete header.header_channel_code
  delete header.header_app_channel_code
  delete header.header_server_code
  body.extra = extra

  var form = document.createElement('form')
  form.style.display = 'none'
  form.action = gateUrl + '/api/sasapi/downLoad'
  form.method = 'post'
  document.body.appendChild(form)
  for (var key in body.extra) {
    var input = document.createElement('input')
    input.type = 'hidden'
    // input.name = "bodyParam." + key; //以前的name
    input.name = 'bodyParam[' + key + ']' // 刚晨光调通的广告那边的
    input.value = body.extra[key]
    form.appendChild(input)
  }
  var datas = {
    appkey: store.getters.appkey,
    code: header.header_view_code,
    header_property_id: header.header_property_id,
    envType: header.header_platform,
    timeType: header.header_time_type
  }
  for (var key in datas) {
    var input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = datas[key]
    form.appendChild(input)
  }
  form.submit()
  form.remove()
}

// 后台下载任务 我的看板 共享看板下载
export function houtaixiazairenwu(header, zitiaojian) {
  if (!zitiaojian) {
    zitiaojian = {}
  }

  header.header_origin = 2 // （数据来源，1：bi统计数据，2：实时数据）
  header.header_appkey = store.getters.appkey // （游戏appkey）
  header.header_platform = store.getters.environment // （环境类型）
  header.header_userid = store.getters.userId // uid
  header.header_rolesid = store.getters.roles.toString() // rolesid

  for (var key in header) {
    if (/.*[\u4e00-\u9fa5]+.*$/.test(header[key])) {
      header[key] = encodeURI(header[key])
    }
  }

  var extra = {}
  var body = {}
  for (var key in header) {
    if (header.hasOwnProperty(key) === true) {
      extra[key] = header[key]
    }
  }

  // alert('子条件111：'+ JSON.stringify(zitiaojian))
  for (var key in zitiaojian) {
    if (zitiaojian.hasOwnProperty(key) === true) {
      extra[key] = zitiaojian[key]
    }
  }

  // delete header.header_channel_code
  // delete header.header_app_channel_code
  // delete header.header_server_code
  body.bodyParam = extra

  var fd = new FormData()
  for (var key in body.bodyParam) {
    fd.append(
      'bodyParam[' + key + ']',
      body.bodyParam[key]
    )
  }
  fd.append('appkey', store.getters.appkey)
  fd.append('code', header.header_view_code)
  fd.append('envType', header.header_platform)

  return request({
    baseURL: gateUrl,
    url: '/api/sasapi/downLoad',
    method: 'post',
    headers: header,
    data: fd
  })
}
